import { ACTION_HISTORY_API_PATH } from 'constants/api';
import { ActionHistoryType } from '../../../domain/account/action-history/types/actionHistoryType';
import { ApiService } from './apiService';

class ActionHistoryApiService extends ApiService<ActionHistoryType> {}

export const actionHistoryApiService = new ActionHistoryApiService(ACTION_HISTORY_API_PATH);
